// Honest empty state for a hub whose section has no MDX yet.
const EmptyState = ({ heading, body }: { heading: string; body: string }) => (
  <div className="border border-dashed border-forest/40 px-6 py-10 text-center md:px-10">
    <p className="text-small">{heading}</p>
    <p className="mx-auto mt-2 max-w-xl text-body">{body}</p>
  </div>
);

export default EmptyState;
